export default __webpack_public_path__ + "static/media/zanskar1.3b08d560.jpg";